/**
 * @generated SignedSource<<3a38e446e7202cfda100e3cfeafdb543>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type teamsFragment$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"teamFragment">;
  readonly " $fragmentType": "teamsFragment";
}>;
export type teamsFragment$key = ReadonlyArray<{
  readonly " $data"?: teamsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"teamsFragment">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "teamsFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "teamFragment"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "7c646dee97e98e57f7f6c63ef7a9deb5";

export default node;
